﻿module.exports = function ($) {
	return {
		init: function () {
			var artefactList = $(".resourceArtefactList").length > 0;
			if (artefactList) this.bindEvents();
		},
		bindEvents: function () {

			$('#load-more-artefacts').on('click', function () {
				var perPage = $(".resourceArtefactList").attr("data-artefactsperpage");
				$(".resourceArtefactList").find('.resourceArtefactList__item:hidden').slice(0, perPage).fadeIn();

				if ($(".resourceArtefactList").find('.resourceArtefactList__item:hidden').length == 0) {
					$('.resourceArtefactList__loadMoreButton').hide();
				}
			});
		}
	}
}